import { docodeHexResponse } from '../../_common/common.utils';
import DeadMemberDetailsActionTypes from './dead-member-report.type';

const INITIAL_STATE = {
	getDeadMemberDetailsListResponse: null,
	getDeadMemberDetailsListArr: [],

	exportDeadMemberDetailsResponse: null,
};

const deadMemberReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET DEAD MEMBER REPORT DETAILS START *********************** */
		case DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_LIST_SUCCESS:
			return {
				...state,
				getDeadMemberDetailsListResponse: action.payload,
				getDeadMemberDetailsListArr: docodeHexResponse(
					action.payload,
					'GetDeadMemberReportKey',
				),
			};

		case DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_LIST_FAILURE:
			return { ...state, getDeadMemberDetailsListResponse: action.payload };

		case DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_LIST_RESPONSE_CHANGED:
			return { ...state, getDeadMemberDetailsListResponse: null };
		/** ***************** GET DEAD MEMBER REPORT DETAILS END *********************** */

		/** *********************  START GET DEAD MEMBER EXPORT REPORT DETAILS  ******************** */
		case DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_EXPORT_SUCCESS:
			return { ...state, exportDeadMemberDetailsResponse: action.payload };

		case DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_EXPORT_FAILURE:
			return { ...state, exportDeadMemberDetailsListResponse: action.payload };

		case DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_EXPORT_RESPONSE_CHANGED:
			return { ...state, exportDeadMemberDetailsListResponse: null };
		/** *********************  END GET DEAD MEMBER EXPORT REPORT DETAILS  ******************** */

		default:
			return state;
	}
};

export default deadMemberReportReducer;
